import { render, staticRenderFns } from "./antiInfo.vue?vue&type=template&id=e490a400&scoped=true&"
import script from "./antiInfo.vue?vue&type=script&lang=js&"
export * from "./antiInfo.vue?vue&type=script&lang=js&"
import style0 from "./antiInfo.vue?vue&type=style&index=0&id=e490a400&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e490a400",
  null
  
)

export default component.exports